import isEmail from "validator/lib/isEmail";

// Database constraints from defiant schema:
// - users.name: VARCHAR(50)
// - users.email: VARCHAR(50)
// - bills.name: VARCHAR(50)
// - bills.description: VARCHAR(255)
// - bills.typical_cost: INT (max reasonable: 999999999)
// - statements.content: TEXT (max 100KB = 102400 bytes)
// - statements.cost: DECIMAL(8,2) (max 999999.99, 2 decimal places)
// - users_transactions.amount: DECIMAL(8,2) (max 999999.99, 2 decimal places)

const MAX_NAME_LENGTH = 50;
const MAX_EMAIL_LENGTH = 50;
const MAX_DESCRIPTION_LENGTH = 255;
const MAX_TYPICAL_COST = 999999999;
const MAX_DECIMAL_AMOUNT = 999999.99;
const MAX_STATEMENT_CONTENT_BYTES = 102400; // 100KB

export const IsValidPassword = (val) =>  {
    const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_])/;
    return val!==undefined && val?.length >= 12 && val.length <= 36 && passwordRegex.test(val)
}

// Validates text with minimum length (no max - use IsValidName or IsValidDescription for max limits)
export const IsValidText = (val) => {
    return val!==undefined && val?.length >= 1
}

// Validates name fields (VARCHAR(50) constraint)
export const IsValidName = (val) => {
    if (val === undefined || val === null) return false;
    const trimmed = val.trim();
    return trimmed.length >= 1 && trimmed.length <= MAX_NAME_LENGTH;
}

// Validates description fields (VARCHAR(255) constraint)
export const IsValidDescription = (val) => {
    if (val === undefined || val === null) return false;
    const trimmed = val.trim();
    return trimmed.length >= 1 && trimmed.length <= MAX_DESCRIPTION_LENGTH;
}

// Validates email with length constraint (VARCHAR(50) constraint)
export const IsValidEmail = (val) => {
    if (val === undefined || val === null || val.length === 0) return false;
    const trimmed = val.trim();
    return trimmed.length <= MAX_EMAIL_LENGTH && isEmail(trimmed);
}

// Validates number input
export const IsValidNumber = (val) => {
    return val!==undefined && val?.length >= 1 && !isNaN(parseFloat(val)) && isFinite(val);
}

// Validates typical cost (INT constraint, reasonable max)
export const IsValidTypicalCost = (val) => {
    if (val === undefined || val === null || val === '') return false;
    const num = parseFloat(val);
    if (isNaN(num) || !isFinite(num)) return false;
    return num > 0 && num <= MAX_TYPICAL_COST && Number.isInteger(num);
}

// Validates decimal amounts (DECIMAL(8,2) constraint: max 999999.99, 2 decimal places)
export const IsValidAmount = (val) => {
    if (val === undefined || val === null || val === '') return false;
    const num = parseFloat(val);
    if (isNaN(num) || !isFinite(num)) return false;
    
    // Check max value
    if (num < 0 || num > MAX_DECIMAL_AMOUNT) return false;
    
    // Check decimal places (max 2)
    const str = val.toString();
    const decimalIndex = str.indexOf('.');
    if (decimalIndex !== -1) {
        const decimalPlaces = str.length - decimalIndex - 1;
        if (decimalPlaces > 2) return false;
    }
    
    return true;
}

// Validates statement content (TEXT field, max 100KB)
export const IsValidStatementContent = (val) => {
    if (val === undefined || val === null) return false;
    // Calculate byte length (UTF-8 encoding)
    const byteLength = new Blob([val]).size;
    return val.length >= 1 && byteLength <= MAX_STATEMENT_CONTENT_BYTES;
}

export const IsValidVenmoUsername = (username) => {
    const pattern = /^@[a-zA-Z0-9_]{5,16}$/;
    return pattern.test(username);
};

